import { render, staticRenderFns } from "./LKMunMehFormRowLink.vue?vue&type=template&id=4b60ca8e&"
import script from "./LKMunMehFormRowLink.vue?vue&type=script&lang=js&"
export * from "./LKMunMehFormRowLink.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehFormRowLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports